import { email, z } from 'zod';
import { toEmptyString } from './preprocess';

/** Email — sem preprocess (signUp, quiz). */
export const emailField = z.email('E-mail inválido');

/** Email — com preprocess (nationalUserSchema). */
export const emailPreprocess = z.preprocess(
  toEmptyString,
  email('Email inválido.')
);
